import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import AddFabricInline from '@components/materials/AddFabricInline';
import ModalContainer from '@components/modals/ModalContainer';
import NitexImageCropper from '@components/NitexImageCropper';
import { toastError, toastSuccess, toastWarning } from '@components/Toast';

import AddLocationModal from '@features/design/components/AddLocationModal';
import AllSampleAccordion from '@features/design/components/AllSampleAccordion';
import DesignBasicInfoSection from '@features/design/components/DesignBasicInfoSection';
import {
	createBrandResponseOnSelectBuyerTP,
	createCountryResponseOnSelectSampleId,
	createInitialSampleData,
	createSampleTypeOnSelectSampleId,
	DESIGN_INFO_INITIAL_STATE,
	USER_TYPES
} from '@features/design/utils/designUtils';

import { fetchProductInfo } from '@store/actions/DesignToolAction';
import { closeLoader, openLoader } from '@store/actions/LoaderAction';
import { getBrands, getFabricTypes, getMarkets } from '@store/design/action';
import { getAllBrands, getAllFabricTypes, getAllMarkets, useDesignViewModal } from '@store/reducers';
import { setUpdatedArchivedProductId } from '@store/searchOptions/actions';

import { getProductInfoByProductId } from '@services/commonService';
import { fetchAllProductTags, saveProductRemarks } from '@services/collectionService';
import { findAllSupplier } from '@services/costingService';
import {
	deleteProductImage,
	fetchBodyFabric,
	fetchDesignLooks,
	fetchProductCategories,
	fetchUsersListByRole,
	getProductSampleLocations,
	getProductSamples,
	getSampleCountryList,
	replaceBodyFabric,
	submitSampleUpdate,
	uloadProductImage,
	updateBodyFabric,
	updateCroppedImageOnSave,
	updateDesignBasicInfo,
	updateSampelInventory
} from '@services/designInfoUpdateService';

import ApiClient from '@lib/apiClient';

import { isValidFile, printApiError } from '@utils/Util';

import { VALID_FILE_SIZE } from '@/constants/constant';

const DesignUpdate = ({
	productId,
	onSetNitexTab,
	activeId,
	isNitexTechpack,
	onChangeActiveTab,
	requestFrom,
	setProductDocumentList,
	onCloseALl,
	fetchDesignPublishStatus
}) => {
	// Design Basic info Section Sates
	const [isDesignEdit, setIsDesignEdit] = useState(false);
	const [selectedDesignInfo, setSelectedDesignInfo] = useState(DESIGN_INFO_INITIAL_STATE);
	const [categories, setCategories] = useState([]);
	const [fabricType, setFabricType] = useState([]);
	const [bodyFabric, setBodyFabric] = useState([]);
	const [designers, setDesigners] = useState([]);
	const [tpCompleatedBy, setTpCompleatedBy] = useState([]);
	const [looks, setLooks] = useState([]);
	const [tags, setTags] = useState([]);
	const [selectedImage, setSelectedImage] = useState(null);
	const [designDetails, setDesignDetails] = useState({});
	const [isCropImage, setIsCropImage] = useState(false);
	const [mainImageUrl, setMainImageUrl] = useState('');
	const [croppedBodyData, setCroppedBodyData] = useState({
		id: '',
		base64Str: '',
		docMimeType: 'image/jpeg',
		extension: 'jpeg'
	});
	const markets = useSelector(getAllMarkets);
	const [marketList, setMarketList] = useState([]);
	const allFabricTypes = useSelector(getAllFabricTypes) || [];
	const brandsList = useSelector(getAllBrands) || [];
	const [countryList, setCountryList] = useState([]);
	const [brands, setBrands] = useState([]);
	const dispatch = useDispatch();
	const [mainFabric, setMainFabric] = useState(null);
	// Sample Accordion States
	const [locationsList, setLocationsList] = useState([]);
	const [showAddLocationModal, setShowAddLocationModal] = useState(false);
	const [allSampleList, setAllSampleList] = useState([]);
	const [selectedRowId, setSelectedRowId] = useState(null);
	const [suppliers, setSuppliers] = useState([]);
	const [sampleErrors, setSampleErrors] = useState([]);
	const [selectdSampleToEdit, setSelectdSampleToEdit] = useState(null);
	const [, setTouchedRows] = useState([]); // To check if user put sample Inventroy value.
	const [isOpenAddNewFabricModal, setIsOpenAddNewFabricModal] = useState(false);
	const [parentId, setParentId] = useState(null);
	const [activeRow, setActiveRow] = useState(null);
	const [newlyAddedFabricData, setNewlyAddedFabricData] = useState(null);
	const [originalSampleResponse, setOriginalSampleResponse] = useState([]); // To Reset sample list when click "Cancel"
	const [originalDesignDetailsResponse, setOriginalDesignDetailsResponse] = useState({});
	const { isUpdateSampleId, isFocusOnModalClose } = useSelector(
		(store) => store.collectionSearchOptionStore
	);
	const [remarks, setRemarks] = useState('');
	const [currentPagePath, setCurrentPagePath] = useState('');
	const { isSoldFolder } = useDesignViewModal();

	const refetchArchiveList = () => {
		if (currentPagePath === '/collections/list') {
			dispatch(setUpdatedArchivedProductId(null));
		}
	};

	useEffect(() => {
		setCurrentPagePath(window.location.pathname);
	}, [window.location.pathname]);

	useEffect(() => {
		refetchArchiveList();
	}, [currentPagePath]);

	useEffect(() => {
		if (designDetails?.collectionRemarks) {
			setRemarks(designDetails?.collectionRemarks);
		}
	}, [designDetails?.collectionRemarks]);

	useEffect(() => {
		if (isUpdateSampleId) setIsDesignEdit(true);
	}, [isUpdateSampleId]);

	const onParseInputName = async (type, value) => {
		setIsOpenAddNewFabricModal(true);
		try {
			const { data } = await ApiClient.GET('setParseInputName', `?name=${encodeURIComponent(value)}`);
			setNewlyAddedFabricData({
				fabricType: data.fabricType,
				fabricTypeWithConstruction:
					data.fabricType && data.construction ? `${data.fabricType}-${data.construction}` : '',
				compositionDetails: data.compositionDetails,
				weight: data.weight,
				constructionId: data.constructionId,
				compositionPartList: data.compositionPartList,
				weightType:
					data.fabricType === 'SWEATER' ? 'GAUGE' : data.fabricType === 'DENIM' ? 'OZ' : 'GSM',
				fabricCompositionPartIdList: data.fabricCompositionPartIdList,
				description: data.description
			});
		} catch ({ response }) {
			if (response.data.message) {
				toastError(response.data.message);
			} else {
				toastError('Something went wrong! Please try again.');
			}
		}
	};

	useEffect(() => {
		if (markets?.length) {
			const marketItes = markets.map((item) => ({
				...item,
				value: item?.name
			}));
			setMarketList(marketItes);
		}
	}, [markets?.length]);

	useEffect(() => {
		if (allFabricTypes) {
			const fabricTypes = allFabricTypes.map((fabric) => ({
				id: fabric?.code,
				name: fabric?.value,
				...fabric
			}));
			setFabricType(fabricTypes);
		}
	}, [allFabricTypes.length]);

	const formatProductInfo = async () => {
		try {
			if (productId) {
				let params = `${productId}?checkBuyerSelectionStatus=true`;
				const productInfo = await getProductInfoByProductId(params);
				setParentId(productInfo?.id);
				setDesignDetails({
					...productInfo,
					productGroupId: productInfo?.productGroupResponse?.id
				});

				const designInfo = {
					designNum: productInfo?.systemReferenceNumber,
					buyerDesignNum: productInfo?.referenceNumber,
					selectedMarket: productInfo?.productGroupResponse,
					selectedCategory: productInfo?.subCategoryResponse,
					selectedFabricType: {
						name: productInfo?.mainFabricType,
						id: productInfo?.mainFabricType
					},
					selectedBodyFabric:
						productInfo?.mainFabricResponses?.length > 0
							? {
									name: productInfo?.mainFabricResponses[0]?.name,
									id: productInfo?.mainFabricResponses[0]?.id
								}
							: null,
					selectedBrand: {
						name: productInfo?.brandName,
						id: productInfo?.brandId
					},
					selectedNitexDesign: {
						id: productInfo?.isNitexProduct ? true : false,
						value: productInfo?.isNitexProduct ? 'YES' : 'NO',
						name: productInfo?.isNitexProduct ? 'YES' : 'NO'
					},
					selectedDesigner: {
						id: productInfo?.designer?.id,
						name: productInfo?.designer?.name
					},
					selectedTpCompleatedBy: {
						id: productInfo?.tpCompletedBy?.id,
						name: productInfo?.tpCompletedBy?.name
					},
					selectedLook: {
						id: productInfo?.designLook,
						name: productInfo?.designLook
					},
					selectedTags: [],
					selectedCustomizeBy: {
						id: productInfo?.customizedBy?.id,
						name: productInfo?.customizedBy?.name
					}
				};
				setOriginalDesignDetailsResponse(designInfo);
				// Populate the satate with initial design data
				setSelectedDesignInfo(designInfo);
				setSelectedImage(productInfo?.designDocuments ? productInfo?.designDocuments[0] : null);
				setMainFabric(
					productInfo?.fabrics && productInfo?.fabrics.length > 0 ? productInfo?.fabrics[0] : null
				);
			}
		} catch (error) {
			printApiError(error);
		}
	};

	const getCategories = async () => {
		try {
			const response = await fetchProductCategories();
			setCategories(response);
		} catch (error) {
			printApiError(error);
		}
	};

	const getBodyFabrics = async (searchKey, fabricType) => {
		try {
			const { data } = await fetchBodyFabric(searchKey, fabricType);
			const response = data?.data?.map((item) => ({
				...item,
				value: item?.name
			}));
			setBodyFabric(response);
		} catch (error) {
			printApiError(error);
		}
	};

	const getDesignLooks = async () => {
		try {
			const response = await fetchDesignLooks();
			setLooks(response);
		} catch (error) {
			printApiError(error);
		}
	};

	const getGarmentsTechUsers = async () => {
		try {
			const params = `?userTypes=${USER_TYPES.GARMENTS_TECH}&${USER_TYPES.FASHION_DESIGNER}&${USER_TYPES.GRAPHICS_DESIGNER}&page=0&size=1000`;
			const response = await fetchUsersListByRole(params);
			const designers = response?.filter(
				(item) =>
					item?.primaryUserType === USER_TYPES.FASHION_DESIGNER ||
					item?.primaryUserType === USER_TYPES.GRAPHICS_DESIGNER
			);
			setTpCompleatedBy(response);
			setDesigners(designers);
		} catch (error) {
			printApiError(error);
		}
	};

	const getAllTags = async (searchKey) => {
		try {
			let params = '?type=PRODUCT_COLLECTION_TAGS&entityActivityType=PRODUCT_TAG_UPDATE';
			if (searchKey) {
				params += `&search=${encodeURIComponent(searchKey)}`;
			}
			const data = await fetchAllProductTags(params, null);

			setTags(data);
			dispatch(closeLoader());
		} catch (error) {
			printApiError(error);
		}
	};

	useEffect(() => {
		getCategories();
		dispatch(getMarkets());
		dispatch(getFabricTypes());
		dispatch(getBrands(`?page=0&size=1000`));
		getDesignLooks();
		getGarmentsTechUsers();
		fetchCountryList();
		fetchSuppliers();
		fetchSampleLocations();
	}, [productId]);

	useEffect(() => {
		formatProductInfo();
		if (designDetails && parentId) {
			fetchAllSample();
		}
	}, [productId, parentId]);

	useEffect(() => {
		getBodyFabrics('', selectedDesignInfo?.selectedFabricType?.id);
	}, [selectedDesignInfo?.selectedBodyFabric?.id]);

	useEffect(() => {
		const allBrands = brandsList?.map((brand) => ({
			...brand,
			value: brand?.name
		}));
		setBrands(allBrands);
	}, [brandsList.length]);

	const handleDesignInfoInputChange = (e) => {
		const { value, name } = e.target;
		setSelectedDesignInfo((prev) => ({
			...prev,
			[name]: value
		}));
	};

	const updateCountryResponseOnSelectNitexDesign = (isNitexDesign) => {
		const updatedSamples = allSampleList.map((item) => {
			if (isNitexDesign && item?.rowId === 1 && item?.sampleId) {
				return {
					...item,
					countryResponse: createCountryResponseOnSelectSampleId(1, isNitexDesign),
					sampleType: createSampleTypeOnSelectSampleId(isNitexDesign),
					brandResponse: null
				};
			} else if (isNitexDesign && item?.rowId === 2 && item?.sampleId) {
				return {
					...item,
					countryResponse: createCountryResponseOnSelectSampleId(2, isNitexDesign),
					sampleType: createSampleTypeOnSelectSampleId(isNitexDesign),
					brandResponse: null
				};
			} else if (!isNitexDesign && item?.sampleId) {
				return {
					...item,
					countryResponse: null,
					sampleType: createSampleTypeOnSelectSampleId(isNitexDesign),
					brandResponse: createBrandResponseOnSelectBuyerTP(
						isNitexDesign,
						selectedDesignInfo?.selectedBrand
					)
				};
			} else {
				return {
					...item
				};
			}
		});
		setAllSampleList(updatedSamples);
	};

	const handleSelectDesignInfoOption = (option, dropdownName) => {
		if (dropdownName === 'selectedFabricType') {
			setSelectedDesignInfo((prev) => ({
				...prev,
				[dropdownName]: { ...option },
				selectedBodyFabric: null
			}));

			getBodyFabrics('', option?.id);
		} else if (dropdownName === 'selectedNitexDesign') {
			setSelectedDesignInfo((prev) => ({
				...prev,
				[dropdownName]: { ...option }
			}));
			updateCountryResponseOnSelectNitexDesign(option?.id);
		} else {
			setSelectedDesignInfo((prev) => ({
				...prev,
				[dropdownName]: { ...option }
			}));
		}
	};

	const handleUpdateBodyFabric = async (selectedBodyFabricValue) => {
		try {
			setSelectedDesignInfo((prev) => ({
				...prev,
				selectedBodyFabric: {
					name: selectedBodyFabricValue?.name,
					id: selectedBodyFabricValue?.id
				}
			}));

			if (mainFabric?.id) {
				await replaceBodyFabric(designDetails?.id, selectedBodyFabricValue?.id, mainFabric?.id);
			} else {
				await updateBodyFabric(designDetails?.id, selectedBodyFabricValue?.id);
			}
			const designRequestBody = createDesignRequestBody();
			await updateDesignBasicInfo(designRequestBody, productId);

			dispatch(fetchProductInfo(productId));
		} catch (error) {
			printApiError(error);
		}
	};

	const updateTagList = (payload) => {
		const tagResponse = payload[0]?.tagResponseList;
		setDesignDetails((prev) => ({
			...prev,
			tagResponseList: tagResponse
		}));
	};

	// Upload Design Image and Cropp Image Functionality

	const handleUploadProductImage = async (body) => {
		try {
			dispatch(openLoader());
			const { data } = await uloadProductImage(body, designDetails?.id);
			if (data) {
				if (selectedImage?.id) {
					await deleteProductImage(designDetails?.id, selectedImage.id);
				}
				setSelectedImage({ ...data?.payload });
			}
		} catch (error) {
			printApiError(error);
		} finally {
			dispatch(closeLoader());
		}
	};

	const handleDesignUpload = (e, docType = 'PRODUCT_DESIGN') => {
		let file = e.target.files[0];
		if (file) {
			if (isValidFile(file, file?.type, VALID_FILE_SIZE)) {
				let data = {
					name: file?.name,
					docMimeType: file?.type,
					documentType: docType,
					base64Str: ''
				};
				let reader = new FileReader();
				reader.readAsDataURL(file);
				reader.onload = () => {
					data.base64Str = reader.result;
					handleUploadProductImage(data);
				};
				reader.onerror = function (error) {
					toastError(error);
				};
			} else {
				toastWarning('Please upload file less than 12mb');
			}
		}
	};

	const handleCropeImage = (e, id, img) => {
		setIsCropImage(true);
		setCroppedBodyData({ ...croppedBodyData, id: id });
		setMainImageUrl(img);
	};

	const handleCloseCroperModal = () => {
		setIsCropImage(false);
		setMainImageUrl('');
	};

	const handleSaveCropedImage = async (base64str) => {
		try {
			dispatch(openLoader());
			if (base64str) {
				const { data } = await updateCroppedImageOnSave(
					{ ...croppedBodyData, base64Str: base64str },
					productId
				);
				setSelectedImage(data);
				dispatch(closeLoader());
			} else {
				dispatch(closeLoader());
				toastError('Crop was not successful');
			}
			handleCloseCroperModal();
		} catch (error) {
			printApiError(error);
		} finally {
			dispatch(closeLoader());
		}
	};

	// All Samples Accordion
	const handleSelectSampleLocation = (value, rowId) => {
		setSelectdSampleToEdit(value);
		setShowAddLocationModal(true);
		setActiveRow(rowId);
	};

	const handleChangeSampleInputField = (e, rowId) => {
		const { name, value } = e.target;
		const updatedSampleList = allSampleList.map((item) => {
			if (item?.rowId === rowId) {
				if (name === 'sampleId') {
					setTouchedRows((prev) => [...prev, rowId]);
					return {
						...item,
						[name]: value,
						qcApprovalDate: item?.qcApprovalDate
							? item?.qcApprovalDate
							: new Date().toISOString().split('T')[0],
						countryResponse: item?.countryResponse?.id
							? item?.countryResponse
							: createCountryResponseOnSelectSampleId(
									rowId,
									selectedDesignInfo?.selectedNitexDesign?.id
								),
						sampleType: item?.sampleType
							? item?.sampleType
							: createSampleTypeOnSelectSampleId(selectedDesignInfo?.selectedNitexDesign?.id),
						brandResponse: item?.brandResponse
							? item?.brandResponse
							: createBrandResponseOnSelectBuyerTP(
									selectedDesignInfo?.selectedNitexDesign?.id,
									selectedDesignInfo?.selectedBrand
								),
						sampleStatus: 'AVAILABLE'
					};
				} else {
					setTouchedRows((prev) => [...prev, rowId]);
					return {
						...item,
						[name]: value
					};
				}
			}
			return item;
		});

		setAllSampleList(updatedSampleList);
	};

	const handleSelectSampleOptions = (value, optionName, rowId, isObject = false) => {
		const updatedSampleList = allSampleList.map((item) => {
			if (item?.rowId === rowId) {
				if (optionName === 'sampleType') {
					setTouchedRows((prev) => [...prev, rowId]);
					if (value === 'BUYER_TP_DEVELOPMENT' && !item?.brandResponse?.id) {
						return {
							...item,
							[optionName]: isObject ? { ...value } : value,
							brandResponse: selectedDesignInfo?.selectedBrand,
							supplierResponse: {}
						};
					} else {
						return {
							...item,
							[optionName]: isObject ? { ...value } : value,
							brandResponse: {},
							supplierResponse: {}
						};
					}
				} else {
					setTouchedRows((prev) => [...prev, rowId]);
					return {
						...item,
						[optionName]: isObject ? { ...value } : value
					};
				}
			}
			return item;
		});
		setAllSampleList(updatedSampleList);
	};

	const handleCloseLocationModal = () => {
		setShowAddLocationModal(false);
	};

	const fetchAllSample = async () => {
		try {
			const response = await getProductSamples(productId, 'DESIGN_INFO_VIEW');
			const samplesList = [];
			let rowIdCounter = 1;

			response.forEach((item) => {
				item?.itemList.forEach((list) => {
					samplesList.push({
						...list,
						productResponse: item?.productResponse,
						rowId: rowIdCounter++
					});
				});
			});

			if (samplesList.length <= 0 && parseInt(parentId) === parseInt(productId)) {
				const newEmptyRows = [
					createInitialSampleData(1, productId),
					createInitialSampleData(2, productId)
				];
				setOriginalSampleResponse(newEmptyRows);
				setAllSampleList(newEmptyRows);
			} else if (samplesList.length === 1 && parseInt(parentId) === parseInt(productId)) {
				setOriginalSampleResponse([...samplesList, createInitialSampleData(2, productId)]);
				setAllSampleList([...samplesList, createInitialSampleData(2, productId)]);
			} else {
				setOriginalSampleResponse(samplesList);
				setAllSampleList(samplesList);
			}
		} catch (error) {
			printApiError(error);
		}
	};

	const fetchSampleLocations = async (searchKey = '') => {
		try {
			const params = `?search=${encodeURIComponent(searchKey)}&page=0&size=20`;
			const response = await getProductSampleLocations(params);

			const locationsArr = response?.map((item) => ({
				...item,
				secondLine: [
					item?.countryResponse?.code,
					item?.buildingTagResponse?.text,
					item?.floorTagResponse?.text,
					item?.roomOrAreaTagResponse?.text,
					item?.otherDetails
				]
					.filter(Boolean)
					.join(', ')
			}));
			setLocationsList(locationsArr);
		} catch (error) {
			printApiError(error);
		}
	};

	const fetchCountryList = async () => {
		try {
			const response = await getSampleCountryList();
			setCountryList(response);
		} catch (error) {
			printApiError(error);
		}
	};

	const fetchSuppliers = async (searchKey = '') => {
		try {
			const params = `?page=0&size=20&name=${searchKey}&materialType=GARMENT&sort=id,desc`;
			const { data = [] } = await findAllSupplier(params);

			const suppliersList = data?.map((item) => ({
				...item,
				value: item?.name
			}));

			setSuppliers(suppliersList);
		} catch (error) {
			printApiError(error);
		}
	};

	const handleAddNewRow = () => {
		setAllSampleList((prev) => [
			...prev,
			createInitialSampleData(prev[prev?.length - 1]?.rowId + 1, productId)
		]); // row id = last index +1
	};

	const createDesignRequestBody = () => {
		// Design update request body
		const designInfoRequestBody = {
			id: designDetails.id,
			name: selectedDesignInfo?.name,
			referenceNumber: selectedDesignInfo?.buyerDesignNum,
			systemReferenceNumber: selectedDesignInfo?.designNum,
			productCategoryId: selectedDesignInfo?.selectedCategory?.ctgId,
			productSubCategoryId: selectedDesignInfo?.selectedCategory?.id,
			productGroupId: selectedDesignInfo?.selectedMarket?.id,
			isNitexProduct: selectedDesignInfo?.selectedNitexDesign?.id,
			brandId: selectedDesignInfo?.selectedBrand?.id,
			fabricType: selectedDesignInfo?.selectedFabricType?.id,
			fabricName: selectedDesignInfo?.selectedBodyFabric?.name || null,
			designLook: selectedDesignInfo?.selectedLook?.id,
			tpCompletedById: selectedDesignInfo?.selectedTpCompleatedBy?.id,
			designerId: selectedDesignInfo?.selectedDesigner?.id,
			customizedById: selectedDesignInfo?.selectedCustomizeBy?.id
		};
		return designInfoRequestBody;
	};

	const handleWrongEntry = async (sampleId, isWrongEntry) => {
		try {
			dispatch(openLoader());
			await updateSampelInventory(sampleId, isWrongEntry);
			await fetchAllSample();
		} catch (error) {
			printApiError(error);
		} finally {
			dispatch(closeLoader());
		}
	};

	const createSampleRequestBody = () => {
		// Sample inventory request body
		const sampleInventoryRequestBody = allSampleList.map((item) => {
			const sample = {
				id: item?.id,
				productId: item?.productId,
				sampleId: item?.sampleId,
				countryId: item?.countryResponse?.id,
				qcApprovalDate: item?.qcApprovalDate,
				color: item?.color,
				size: item?.size,
				sampleType: item?.sampleType,
				sampleStatus: item?.sampleStatus ? item?.sampleStatus : item?.sampleId ? 'AVAILABLE' : null,
				remarks: item?.remarks,
				brandId: item?.brandResponse?.id,
				supplierId: item?.supplierResponse?.id,
				sampleInventoryLocationId: item?.sampleInventoryLocationResponse?.id,
				wrongEntrySampleId: item?.wrongEntrySampleId,
				isWrongEntry: item?.isWrongEntry
			};

			const filteredSample = Object.fromEntries(
				Object.entries(sample).filter(([, value]) => value != null)
			);

			return filteredSample;
		});

		return sampleInventoryRequestBody.filter(
			(item) => item?.sampleId && parseInt(parentId) === parseInt(item?.productId)
		);
	};

	// Submit Updated design
	const handleSubmitInfo = async () => {
		const sampleBody = createSampleRequestBody();
		refetchArchiveList();

		try {
			dispatch(openLoader());
			const designRequestBody = createDesignRequestBody();
			const { data: designInfoResponse } = await updateDesignBasicInfo(designRequestBody, productId);
			const sampleResponse = await submitSampleUpdate(sampleBody);
			await saveProductRemarks(productId, `?remarks=${encodeURIComponent(remarks)}`);

			if (designInfoResponse?.success && sampleResponse?.success) {
				await getProductInfoByProductId(productId);
				await fetchAllSample();
				fetchDesignPublishStatus && (await fetchDesignPublishStatus());
				setIsDesignEdit(false);
				toastSuccess('Update Successful!');
				setSampleErrors([]);
				setTouchedRows([]);
				if (isFocusOnModalClose) {
					onCloseALl();
				}
				refetchArchiveList();
			}
		} catch (error) {
			printApiError(error);
		} finally {
			dispatch(closeLoader());
		}
	};

	const handleReset = () => {
		setAllSampleList(originalSampleResponse);
		setSelectedDesignInfo(originalDesignDetailsResponse);
		setIsDesignEdit(false);
		setSampleErrors([]);
	};

	const renderBottomPart = () => {
		const allImageNotDocuments =
			requestFrom === 'SET_PRODUCT_VIEW' ? setProductDocumentList : designDetails?.allNotImageDocuments;
		return (
			<div className="d-flex justify-content-between align-items-center">
				<div className="d-flex align-items-center">
					<div className="uploaded-teckpacks">
						{designDetails?.extraFlag?.isArtBoardCreated && (
							<span
								className={`cursor-pointer chip-square ${
									isNitexTechpack === true ? 'active' : ''
								}`}
								onClick={onSetNitexTab}
							>
								Nitex techpack
							</span>
						)}

						{allImageNotDocuments?.map((item) => (
							<span
								className={`cursor-pointer chip-square ${
									item.id === activeId ? 'active' : ''
								}`}
								key={item.id}
								onClick={() => onChangeActiveTab(item)}
							>
								{item?.name?.length <= 25 ? item?.name : item?.name}
							</span>
						))}
					</div>
				</div>
			</div>
		);
	};

	return (
		<React.Fragment>
			<div className="style-header d-flex justify-content-between align-items-center mb-3">
				<div>
					<p className="regular-16 weight-700 gray_dark_01">STYLE DETAILS</p>
				</div>
				{isDesignEdit && (
					<div className="style-buttons">
						<button
							className="button size32 gray-outline bg-white"
							onClick={() => {
								handleReset();
							}}
						>
							Cancel
						</button>
						<button
							className="button size32 ml-12"
							onClick={() => {
								handleSubmitInfo();
							}}
						>
							Update
						</button>
					</div>
				)}
				{!isDesignEdit && (
					<div className="style-buttons">
						<button
							className="button size32"
							onClick={() => setIsDesignEdit(true)}
							disabled={isSoldFolder}
						>
							Edit
						</button>
					</div>
				)}
			</div>
			<DesignBasicInfoSection
				productId={productId}
				isDesignEdit={isDesignEdit}
				onDesignUpload={handleDesignUpload}
				onCropeImage={handleCropeImage}
				selectedImage={selectedImage}
				categories={categories}
				fabricType={fabricType}
				bodyFabric={bodyFabric}
				designers={designers}
				tpCompleatedBy={tpCompleatedBy}
				looks={looks}
				tags={tags}
				onDesignInputChange={handleDesignInfoInputChange}
				onSelectOption={handleSelectDesignInfoOption}
				onGetBodyFabrics={getBodyFabrics}
				onUpdateTagList={updateTagList}
				onGetAllTags={getAllTags}
				onUpdateBodyFabric={handleUpdateBodyFabric}
				selectedDesignInfo={selectedDesignInfo}
				marketList={marketList}
				brands={brands}
				designDetails={designDetails}
				onParseInputName={onParseInputName}
				remarks={remarks}
				setRemarks={setRemarks}
			/>
			<AllSampleAccordion
				isDesignEdit={isDesignEdit}
				setIsDesignEdit={setIsDesignEdit}
				onChangeSampleInputField={handleChangeSampleInputField}
				onSelectOptions={handleSelectSampleOptions}
				onSelectSampleLocation={handleSelectSampleLocation}
				onAddNewRow={handleAddNewRow}
				allSampleList={allSampleList}
				selectedRowId={selectedRowId}
				setSelectedRowId={setSelectedRowId}
				countryList={countryList}
				setAllSampleList={setAllSampleList}
				brands={brands}
				suppliers={suppliers}
				errors={sampleErrors}
				fetchSuppliers={fetchSuppliers}
				getBrands={getBrands}
				fetchSampleLocations={fetchSampleLocations}
				locationsList={locationsList}
				onWrongEntry={handleWrongEntry}
				parentId={parentId}
				isNetexDesign={selectedDesignInfo?.selectedNitexDesign?.value}
				designDetails={designDetails}
			/>
			{renderBottomPart()}
			{showAddLocationModal && (
				<AddLocationModal
					onClose={handleCloseLocationModal}
					locationsList={locationsList}
					fetchSampleLocations={fetchSampleLocations}
					countryList={countryList}
					selectdLocationToEdit={selectdSampleToEdit}
					setShowAddLocationModal={setShowAddLocationModal}
					setAllSampleList={setAllSampleList}
					activeRow={activeRow}
				/>
			)}
			{isOpenAddNewFabricModal && (
				<ModalContainer
					onCloseModal={() => setIsOpenAddNewFabricModal(false)}
					className="add-location-modal"
				>
					<div className="popup-wrapper shadow-lg">
						<AddFabricInline
							productId={productId}
							materialType="MAIN_FABRIC"
							fabricData={newlyAddedFabricData}
							existingId={mainFabric?.id || null}
							onClose={() => setIsOpenAddNewFabricModal(false)}
							onSuccess={async () => {
								dispatch(fetchProductInfo(productId));
								setIsOpenAddNewFabricModal(false);
							}}
							className="common-popup add-location-modal  p-3"
						/>
					</div>
				</ModalContainer>
			)}

			{isCropImage && (
				<NitexImageCropper
					isEdit={isCropImage}
					onClose={handleCloseCroperModal}
					imageSrc={mainImageUrl}
					onSave={handleSaveCropedImage}
				/>
			)}
		</React.Fragment>
	);
};

export default DesignUpdate;
